export default {
      id: "footer_telephone-usage",
      viewBox: "0 0 11 14",
      url: "../dist/images/" + "sprite.svg#footer_telephone-usage",
      toString: function () {
        return this.url;
      }
    }